var i18n = require('i18n');
var ajax = require('@enhancer/fe-util-ajax');
var pop = require('@enhancer/fe-pop');
var util = {};
var pageConfig = window.pageConfig;

util.defaultAvatar = 'https://user-center-assets.enhancer.io/avatar.png';
util.getCookie =  function (name) {  
  var i; 
  var cookie;
  var cookieStr;           
  var cookies = document.cookie.split(";");       

  for (i = 0; i < cookies.length; i++) {      
    cookie = cookies[i];            
    cookieStr = cookie.split("=");
    if (cookieStr && cookieStr[0].replace(/^(\s*)|(\s*)$/g, "") == name) {              
        return  decodeURI(cookieStr[1]);        
    }
  }
}

util.setCookie = function (name, value, expire, domain, path, secure) {                    
  var date = new Date();;  
  var str = escape(name) + "=" + escape(value);       
      
  date.setTime(date.getTime() +  expire );
  str += domain ?   "; domain=" + domain : "";
  str += path ?  "; path=" + path : "";
  str +=  expire ? "; expires=" + date.toGMTString() : "";
  str += secure ? "; secure" : "";
  document.cookie = str;
}

util.showConfirm = function (msg, confirm, deny) {
  var footer = {};
  footer[i18n('common.confirm')] = confirm;
  pop.show({
    title: i18n('common.tip'),
    close: true,
    width: 300,
    content: msg,
    footer: footer,
    onHide: function (from) {
      if (from === 'close') {
        deny && deny();
      }
    }
  });
}


function zero (n) {
  return n > 9 ? n : '0' + n;
}
util.zero = zero;

function format (date, year) {
  date = new Date(date);
  return (year ? date.getFullYear() + '-' : '') +  (zero(date.getMonth() + 1) + '-' + zero(date.getDate()) + ' ' + 
    zero(date.getHours()) + ':' + zero(date.getMinutes()));
};

util.format = format;


function getBlob (url, map, cb) {
  var xhr = new XMLHttpRequest();
  xhr.open('GET', url, true);
  xhr.responseType = 'blob';
  xhr.onload = function(e) {
    if (this.status == 200) {
      map[url] = this.response;
      map.count++;
      if (map.len === map.count) {
        cb();
      }
    } else {
      cb(true);
    }
  };
  xhr.onerror = function () {
    cb(true);
  }
  xhr.send();
}

util.getBlob = getBlob;


/// 改成后端传
var credential;
function doGetCredential (cb) {
  if (credential) {
    return cb(credential);
  }

  ajax({
    url: pageConfig.projectName + '/topic/osscredential'
  }, function (res) {
    if (res.success) {
      credential = res;
      setTimeout(function () {
        credential = null;
      }, 55 * 1000);
    }
    cb(res);
  });
}
function getCredential (blobMap, keys, index, files, cb) {
  doGetCredential(function (res) {
    if (!res.success) {
      return util.show(res.message);
    }
    var params = res.credential.params;
    var formData = new FormData();
    //var file = dataURLtoFile(src, 'avatar.png');
    var now = Date.now();
    
    formData.append('key', params.key + now + index);
    formData.append('policy', params.policy);
    formData.append('OSSAccessKeyId', params.OSSAccessKeyId);
    formData.append('success_action_status', params.success_action_status);
    formData.append('signature', params.signature);
    formData.append('file', blobMap[keys[index]]);
    ajax({
      url: res.credential.host,
      type: 'POST',
      data: formData,
      processData: false,
      contentType: false,
      crossDomain: true
    }, function () {
      var url = res.credential.host + '/' + params.key + now + index;
      files.push({
        fieldname: index,
        url: url
      })

      if (index + 1 < keys.length) {
        getCredential(blobMap, keys, index + 1, files, cb);
      } else {
        cb();
      }
    }, function () {
      util.show(i18n('uploadFail'), 'error');
    });
  })
}

function uploadImage (content, type, cb) {
  var imgs = type === 'html' ?  content.match(/<img [^>]*src=['"]blob([^'"]+)[^>]*>/gi) : content.match(/!\[.*\]\(blob:[^)]+\)/gi);
  var urlReg = type === 'html' ? /<img [^>]*src=['"](blob[^'"]+)[^>]*>/ : /!\[.*\]\((blob:[^)]+)\)/;
  
  
  if (imgs && imgs.length) {
    util.showLoading(true);
    
    var blobMap = {};
    blobMap.len = imgs.length;
    blobMap.count = 0;
    imgs.forEach( function (item) {
      var url = item.match(urlReg)[1];
      
      getBlob(url, blobMap, function (error) {
        if (!error) {
          delete blobMap.count;
          delete blobMap.len;

          var keys = Object.keys(blobMap);
          var files = [];

          getCredential(blobMap, keys, 0, files, function () {
            files.forEach( function (item) {
              var url = keys[item.fieldname];
              content = content.replace('data-mce-src="' + url +'"', '');
              content = content.replace(url, item.url);
            })
            window.clearUploadFile && window.clearUploadFile();
            cb(content);
            setTimeout(() => { ////
              util.showLoading(false);
            }, 500);
          });
        } else {
          console.error(error); ////
          util.showLoading(false);
        }
      });
    })
  } else {
    cb();
  }
}


util.uploadImage = uploadImage;


function toArray (obj) {
  var arr = [];
  for (var  i in obj) {
    arr.push({
      key: i,
      value: obj[i]
    })
  }
  return arr;
}

util.toArray = toArray;


function showLoading (show, msg, modal) {
  if (show) {
    pop.show({
      mask: !!msg,
      icon: 'loading',
      content: msg || 'loading',
      timeout: 1000000000
    })
  } else {
    pop.hide();
  }
}

util.showLoading = showLoading;

util.show = function (msg, type, cb) {
  type = type || 'error';
  pop.show({
    icon: type,
    content: msg,
    onHidden: cb
  });
}

util.hide = function() {
  pop.hide()
}

util.handleDate = function (date) {
  var ret = {
    tip: util.format(date, true)
  }
  date = new Date(date);
  var stamp = date.getTime();
  var now = (new Date).getTime();
  var diff = now - stamp;

  if (diff < 120000) {
    ret.text = i18n('just.now');
  } else if (diff < 86400000) {
    if (diff < 3600000) {
      ret.text = Math.floor(diff / 60000) + i18n('minute.ago');
    } else  {
      ret.text = Math.floor(diff / 3600000) + i18n('hour.ago');
    }
  } else if (diff < 2678400000) {
    ret.text = Math.floor(diff / 86400000) + i18n('day.ago');
  } else if (diff < 31536000000) {
    ret.text = Math.floor(diff / 2592000000) + i18n('month.ago');
  } else {
    ret.text = Math.floor(diff / 31536000000) + i18n('year.ago');
  }
  return ret;
}

util.getUid = function () {
  const uid = util.getCookie('uid');
  if (!uid) {
    return '';
  }

  return parseInt(decodeURIComponent(uid), 10);
}
util.setHash = function (query) {
  query = query || {};
  var keys = Object.keys(query);

  var hash = (location.hash || '').substring(1);
  var hashs = hash.split('&').filter(function(item) {
    if (!item) {
      return false;
    }
    return !keys.some(function (key) { 
      return item.indexOf(key + '=') === 0; 
    });
  });

  hashs = hashs.concat(keys.map(function (key) {
    return key + '=' + query[key];
  }));

  location.hash = hashs.join('&');
}

module.exports = util;


// WEBPACK FOOTER //
// ./src/app/util.js